export default __webpack_public_path__ + "static/pic01-18073658d58ae6f10a752d003eba35be.jpg";